import React from 'react';
import styled from 'styled-components';
import i18next from 'i18next';
import { compose, withHandlers } from 'recompose';
import { push } from 'connected-react-router';
import { rgba } from 'polished';
import { connect } from 'react-redux';
import { Row, Col, Button } from '@ui/atoms';
import { isCabinet } from '@lib/is-cabinet';
import { formatDate } from '@lib/format-date';
import { declOfNum } from '@lib/decl-of-num';
import { RenderIfConnected } from '../../common/organisms';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Mixins } from 'planoplan-ui-kit/core/mixins';

const enchance = compose(
  connect(),
  withHandlers({
    handleClick: ({ onClose, dispatch }) => () => {
      if (isCabinet) {
        dispatch(push('./tariff-managment'));
      } else {
        window.location = `/${window._lang}/cabinet/tariff-managment`;
      }

      onClose();
    },
  })
);

export const LiscenseView = ({ tariff, count, expire, handleClick, hasQuota, quotaFree, quotaLimit, goods }) => (
  <Container>
    <RenderIfConnected cond={goods}>
      <Row>
        <TariffName>{tariff.name}</TariffName>&nbsp;
        {count && (
          <span>
            {count}&nbsp;
            {declOfNum(count, [
              i18next.t('cabinet.widget.license'),
              i18next.t('cabinet.widget.licenses'),
              i18next.t('cabinet.widget.licenses'),
            ])}
          </span>
        )}
      </Row>
      {tariff.alias === 'start' && (
        <Row rowGap={'10px'}>
          <UpgadeButton onClick={handleClick}>{i18next.t('cabinet.tariff.upgrade')}</UpgadeButton>
        </Row>
      )}
      {expire > 0 && (
        <Row rowGap="9px">
          <Section part={18}>
            <Heading>
              {declOfNum(count, [
                i18next.t('cabinet.license.active.untill_0'),
                i18next.t('cabinet.license.active.untill_1'),
                i18next.t('cabinet.license.active.untill_1'),
              ])}
            </Heading>
            <div>{formatDate(expire)}</div>
          </Section>
          {/*Подумать как отобразить сломанный диск*/}
          {hasQuota && (
            <Section part={18}>
              <Heading>{i18next.t('cabinet.balance.free_space')}</Heading>
              {hasQuota ? (
                <div>
                  {quotaFree} {i18next.t('cabinet.misc.of')} {quotaLimit}
                </div>
              ) : (
                <div>{i18next.t('cabinet.misc.undefined')}</div>
              )}
            </Section>
          )}
        </Row>
      )}
    </RenderIfConnected>
  </Container>
);

export const License = enchance(LiscenseView);

const Container = styled.div`
  font-size: 14px;
  font-weight: 500;
  padding: 15px 18px 18px 18px;
  background-color: ${Colors.dark_cream};
  border-radius: 10px;
  box-shadow: 0 4px 10px 0 ${rgba(Colors.black, 0.15)};
  color: ${Colors.coal};
`;

const Heading = styled.div`
  font-size: 12px;
  color: #808080; //TODO цвет
  margin-bottom: 2px;
`;

const Section = styled(Col)`
  text-align: left;
`;

const UpgadeButton = styled(Button)`
  ${Mixins.transition('background-color')};
  background-color: ${Colors.coal};
  color: ${Colors.white};
  font-size: 14px;
  height: 34px;

  &:hover {
    background-color: #808080; //TODO цвет
  }
`;

const TariffName = styled.span`
  text-transform: uppercase;
  font-weight: 500;
`;
